"use client";

import Link from "next/link";
import Nimage from "./image";
import { useConfig } from "./ConfigProvider";

export default async function ProjectNavigation({ _data, element, config }: any) {
    if (config == null) {
        config = useConfig();
    }
    const pagedata: any = config?.pages;

    if (!_data || !pagedata) return;
    const projectPages = pagedata.filter((page: { pid: number }) => page.pid === 33);
    const currentIndex = projectPages.findIndex((page: { uid: number }) => Number(_data.pid) === Number(page.uid));
    if (currentIndex == -1) {
        return "Current Page not found";
    }
    const prevPage = currentIndex > 0 ? projectPages[currentIndex - 1] : null;
    const nextPage = currentIndex < projectPages.length - 1 ? projectPages[currentIndex + 1] : null;

    return (
        <>
            {prevPage ? (
                <Link href={`${prevPage.slug}`} className="cir-butn line-butn icon-200 d-inline-flex me-2">
                    <div className="cont"> <span className="txt fsz-20">{_data?.previousbuttonlabel1747722770}</span>
                        {_data?.previousarrowimage1747722784?.length > 0 ? _data?.previousarrowimage1747722784.map((immg: any, index: any) => (
                            <Nimage key={_data?.uid + immg?.url + index + 'previousarrowimage1747722784'} immg={immg} data={_data} className="arrow" />
                        )) : null}
                    </div>
                </Link>
            )
                :
                <button className="cir-butn line-butn icon-200 d-inline-flex me-2 opacity-50 cursor-not-allowed" disabled>
                    <div className="cont"> <span className="txt fsz-20">{_data?.previousbuttonlabel1747722770}</span>
                        {_data?.previousarrowimage1747722784?.length > 0 ? _data?.previousarrowimage1747722784.map((immg: any, index: any) => (
                            <Nimage key={_data?.uid + immg?.url + index + 'previousarrowimage1747722784'} immg={immg} data={_data} className="arrow" />
                        )) : null}
                    </div>
                </button>
            }
            {nextPage ? (
                <Link href={`${nextPage.slug}`} className="cir-butn icon-200 d-inline-flex">
                    <div className="cont"> <span className="txt fsz-20">{_data?.nextbuttonlabel1747722808}</span>
                        {_data?.nextarrowimage1747722822?.length > 0 ? _data?.nextarrowimage1747722822.map((immg: any, index: any) => (
                            <Nimage key={_data?.uid + immg?.url + index + 'nextarrowimage1747722822'} immg={immg} data={_data} className="arrow" />
                        )) : null}
                    </div>
                </Link>
            )
                : <button className="cir-butn icon-200 d-inline-flex opacity-50 cursor-not-allowed" disabled>
                    <div className="cont"> <span className="txt fsz-20">{_data?.nextbuttonlabel1747722808}</span>
                        {_data?.nextarrowimage1747722822?.length > 0 ? _data?.nextarrowimage1747722822.map((immg: any, index: any) => (
                            <Nimage key={_data?.uid + immg?.url + index + 'nextarrowimage1747722822'} immg={immg} data={_data} className="arrow" />
                        )) : null}
                    </div>
                </button>
            }
        </>
    )

}